export interface TierBracket {
  readonly min: number;
  readonly visualTier: string;
  readonly badgeTier: number;
}

const TIER_BRACKETS: readonly TierBracket[] = [
  { min: 100, visualTier: 't7', badgeTier: 4 },
  { min:  50, visualTier: 't6', badgeTier: 4 },
  { min:  25, visualTier: 't5', badgeTier: 3 },
  { min:  10, visualTier: 't4', badgeTier: 3 },
  { min:   5, visualTier: 't3', badgeTier: 2 },
  { min:   2, visualTier: 't2', badgeTier: 2 },
];

const DEFAULT_VISUAL_TIER = 't1';
const DEFAULT_BADGE_TIER = 1;

export function visualTier(mult: number): string {
  for (const b of TIER_BRACKETS) {
    if (mult >= b.min) return b.visualTier;
  }
  return DEFAULT_VISUAL_TIER;
}

export function badgeTier(mult: number): number {
  for (const b of TIER_BRACKETS) {
    if (mult >= b.min) return b.badgeTier;
  }
  return DEFAULT_BADGE_TIER;
}

export function badgeTierClass(mult: number): string {
  return `tier-${badgeTier(mult)}`;
}
